import { render, staticRenderFns } from "./data-exports-to-china.vue?vue&type=template&id=5574abe9&scoped=true"
import script from "./data-exports-to-china.vue?vue&type=script&lang=js"
export * from "./data-exports-to-china.vue?vue&type=script&lang=js"
import style0 from "./data-exports-to-china.vue?vue&type=style&index=0&id=5574abe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5574abe9",
  null
  
)

export default component.exports